import type { AppDataTableColumn } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AppBadgeForID, AppMemberDisplay } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import type { ActionLog } from 'backend/types'
import { ACTION_CATEGORIES } from 'shared'
import { formatDate } from '@/lib/format-utils'

/**
 * 操作内容テキストを生成
 */
function getActionText(log: ActionLog): string {
  const action = `${log.action_log_type_name}しました`

  switch (log.action_category_id) {
    case ACTION_CATEGORIES.OPPORTUNITY:
      return `オポチュニティ管理番号${log.dst_opportunity_id}を${action}`
    case ACTION_CATEGORIES.OPPORTUNITY_COMMENT:
      return `オポチュニティコメント管理番号${log.dst_opportunity_comment_id}を${action}`
    case ACTION_CATEGORIES.OPPORTUNITY_TASK:
      return `オポチュニティタスク管理番号${log.dst_opportunity_task_id}を${action}`
    default:
      return action
  }
}

/**
 * 操作ログ一覧のカラム定義を生成
 * @returns カラム定義の配列
 */
export function createLogColumns(): AppDataTableColumn<ActionLog>[] {
  return [
    {
      key: 'id',
      label: '管理ID',
      accessor: (row) => row.id,
      render: (row) => <AppBadgeForID value={row.id} />,
    },
    {
      key: 'created_at',
      label: '操作日時',
      accessor: (row) => row.created_at,
      sortable: false,
      render: (row) => (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className='cursor-help'>{formatDate(row.created_at, 'relative')}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{formatDate(row.created_at, 'datetime')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ),
    },
    {
      key: 'src_member_name',
      label: '実行者名',
      accessor: (row) => row.src_member_name,
      sortable: false,
      render: (row) => <AppMemberDisplay employeeNumber={row.src_employee_number} name={row.src_member_name} />,
    },
    {
      key: 'action_log_type_name',
      label: '操作区分',
      accessor: (row) => row.action_log_type_name,
      sortable: false,
      render: (row) => <span>{row.action_log_type_name || '-'}</span>,
    },
    {
      key: 'text',
      label: '操作内容',
      accessor: (row) => getActionText(row),
      sortable: false,
      render: (row) => <span>{getActionText(row)}</span>,
    },
  ]
}
